<template>
    <span>
        <a :href="href"
           class="ml-2 stripe-connect"
           slot="title-suffix"
           @click="click($event)">
            <span v-if="connect">{{$t('button.stripe_connect')}}</span>
            <span v-else>{{$t('button.stripe_disconnect')}}</span>
        </a>
        <modal
            v-if="!connect"
            @ok="$emit('disconnect')"
            @hide="showDisconnectConfirmModal = false"
            :confirm="$t('button.disconnect')"
            :showModal="showDisconnectConfirmModal">
            <template slot="body">
                <h3 class="text-center">{{$t('button.stripe_disconnect')}}</h3>
                <p class="text-center">{{$t('resources.stripe_disconnect_confirmation')}}</p>
            </template>
        </modal>
    </span>
</template>

<script>
  export default {
    name: "stripeConnectButton",
    props: {
      href: {
        type: String,
        default: ''
      },
      connect: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        showDisconnectConfirmModal: false
      }
    },
    methods: {
      click(event) {
        if (!this.connect) {
          event.preventDefault();

          this.showDisconnectConfirmModal = true;
        }
      }
    }
  }
</script>